import React, { Component } from 'react';
import { URLImgFront } from '../../../config/URLDB';

class Seccion03CooperaGanaMas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeButton: null
        };
    }

    getActiveButton = (isActive) => {
        return {
            outline: 'none',
            display: 'block',
            margin: 'auto',
            transition: 'transform 0.15s ease',
            transform: isActive ? 'scale(0.96)' : 'scale(1)',
            backgroundColor: 'transparent',
            border: 0
        };
    }

    scrollToStar = () => {
        const target = document.getElementById("seccion01");
        if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    render() {
        window.scrollTo(0, 0);
        const { activeButton } = this.state;
        return (
            <React.Fragment>
                <section className="cooperaGanaMas-container context03" style={{ background: 'linear-gradient(to right, #E8561B, #FFCE00)' }}>
                    <img
                        data-aos="zoom-in"
                        data-aos-delay="300"
                        alt="Present"
                        src={`${URLImgFront}/assets/EstrategiasComerciales/present.svg`}
                        className="bg-icon bg-icon-sec03"
                    />
                    <div className="cooperaGanaMas-content">
                        <div className="cooperaGanaMas-text">
                            <div className="titleContainer">
                                <h2 className="title" data-aos="flip-up" data-aos-delay="300">Plan de</h2>
                                <p data-aos="flip-down" data-aos-delay="300" className="highlighted bigger">Premios</p>
                            </div>
                            <p data-aos="zoom-in-right" data-aos-delay="300" className="text itemsWrapper">Entre más puntos acumules, más oportunidades de ganar recibirás para el sorteo. <br /></p>
                            <p data-aos="zoom-in-right" data-aos-delay="300" className="text itemsWrapper">Cada <b>oportunidad de ganar</b> tiene un valor de <b>200 puntos.</b></p>
                            <img
                                src={`${URLImgFront}/assets/EstrategiasComerciales/premiosCooperaGanaMas.png`}
                                data-aos="fade-up"
                                alt="PremiosCamp"
                                className="description-image" />
                        </div>


                        <div className="cooperaGanaMas-image-wrapper">
                            <img src={`${URLImgFront}/assets/EstrategiasComerciales/infoPremiosCooperaGanaMas.svg`}
                                data-aos="zoom-out"
                                data-aos-delay="300"
                                alt="InfoPremiosCamp"
                                className="cooperaGanaMas-image sec03" />
                        </div>
                    </div>

                    <div className='boton-container adaptable'>
                        <button
                            id={"btnRegresar"}
                            className="button-img"
                            data-id={0}
                            style={this.getActiveButton(activeButton === 0)}
                            onClick={this.scrollToStar}
                            onTouchEnd={() => {
                                this.setState({ activeButton: null });
                                this.scrollToStar();
                            }}
                        >
                            <img
                                data-aos="zoom-in"
                                data-duration="900"
                                data-aos-delay="300"
                                src={`${URLImgFront}/assets/EstrategiasComerciales/Boton_regresar.png`}
                                alt="Anterior"
                                style={{ width: '100%', height: '90px', touchAction: 'manipulation' }}
                            />
                        </button>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

export default Seccion03CooperaGanaMas;